import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication.service';

@Component({
  standalone: false,
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.css'],
})
export class SsoComponent implements OnInit {
  accessToken: string | null = null;
  isLoading = true;

  constructor(private _authentication: AuthenticationService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    const token = sessionStorage.getItem('accessToken')
    if (!token){
     this.route.queryParams.subscribe((params) => {
       this.accessToken = params['otc'];
       console.log(this.accessToken);

       if (this.accessToken) {
         this.isLoading = true; // Set loading to true before making the HTTP request

        this._authentication.ssologin(this.accessToken).subscribe({
          next: () => {
            this.isLoading = false; 
            window.location.reload()
          },
           error: (error) => {
             console.error('Login failed:', error);
             this.isLoading = false;
              this.router.navigate(['/']);
           },
         });
       }
     });
    }else{
      this.isLoading = true;
       this.router.navigate(['/']);
    }
  }
}
